<template>
  <!-- 转让选择管理员 -->
  <div class="my-select">
    <div class="select-div-top">
      <div class="aifv-bg"></div>
      <form action="/" class="logo-container">
        <van-search v-model="searchValue" right-icon="" shape="round" placeholder="搜索内容" @search="onCourseSearchEnter"
          :clearable="true" clear-trigger="always" @clear="clearSearchValue">
          <template #left-icon>
            <van-icon name="search" />
          </template>
        </van-search>
      </form>
    </div>
    <ul class="list" v-if="list.length > 0">
      <van-list v-model="loading" v-if="list.length > 0 && !isNone" :finished="finished" finished-text="我是有底线的"
        loading-text="正在加载..." @load="onLoad">
        <li v-for="(item,index) in list" :key="item.id" class="list-item" @click="handleChange(item,index)">
          <img src="@/assets/images/grade/select.png" v-if="item.checkedPush" class="icon-check" alt="">
          <img src="@/assets/images/teacher-task/un-select.png" v-else class="icon-check" alt="">
            <img src="../../../assets/images/grade/icon-doctor.png" class="avatar" />
            <div class="info">
              <div class="name">{{ item.realName }}</div>
            </div>
        </li>
      </van-list>
    </ul>
    <div class="empty-block" v-else>
      <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
      <div class="empty-txt">暂无内容</div>
    </div>
    <button class="confirm-button" @click="handleOk">确定</button>
  </div>
</template>
<script>
import { debounce } from '@/utils/util'
import { getJohnsonUser, transferClassroom } from '@/api/grade'
import { Toast } from 'vant'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'selectMember',
  data() {
    return {
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      load: false,
      isNone: false,
      list: [],
      searchValue: '',
      selectedList: [],
      selectedIdList: [],
      checkedPush: false,
      transferUserId: '',
      classId: '',
    }
  },
  created() {
    this.classId = this.$route.query.classId
  },
  computed: {
    userId () {
      return this.$store.getters.userInfo.id
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    handleChange(item, index) {
      this.list.forEach(acc => {
        if (acc.id === item.id) {
          this.transferUserId = item.id
          acc.checkedPush = true
        } else {
          acc.checkedPush = false
        }
      })
      this.$forceUpdate()
    },
    onLoad() {
      if (this.load) {
        return
      }
      this.load = true
      const params = {
        realName: this.searchValue,
        memberType: 1,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      getJohnsonUser(params).then(res => {
        this.load = false
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        this.list = this.list.concat(res.data.list)
        this.list.forEach(acc => {
          acc.checkedPush = false
        })
        // 加载状态结束
        this.loading = false
        if (this.list.length <= 0) {
          this.isNone = true
        } else {
          this.isNone = false
        }
        this.pageNum++
      })
    },
    handleOk: debounce(function() {
      if (!this.transferUserId) {
        return this.$toast('转让人不能为空')
      }
      const params = {
        classId: this.classId,
        userId: this.userId,
        transferUserId: this.transferUserId
      }
      transferClassroom(params).then(res => {
        sessionStorage.removeItem('createGrade')
        sessionStorage.removeItem('classId')
        this.$router.push({
          path: '/grade',
        })
        Toast('操作成功！')
      })
    }, 500),
    clearSearchValue() {
      this.searchValue = ''
      this.pageNum = 1
      this.pageSize = 10
      this.loading = false
      this.finished = false
      this.finishText = '没有更多了'
      this.list = []
      this.onLoad()
    },
    onCourseSearchEnter: debounce(function () {
      this.pageNum = 1
      this.pageSize = 10
      this.loading = false
      this.finished = false
      this.finishText = '没有更多了'
      this.list = []
      this.onLoad()
    }, 400),
  }
}
export default withRouteTracking(UserProfile)
</script>
<style scoped lang="less">
.my-select {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: #f5f5f5;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 146px;
    background-image: url('../../../assets/images/grade/student-bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .select-div-top {
    position: relative;
  }

  .aifv-div-top {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 70px;
  }

  .aifv-bg {
    height: 62px;
    width: 100%;
  }

  /deep/ .van-search {
    background: transparent;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    padding: 12px 16px 10px;
    box-sizing: border-box;

    .van-search__content {
      border: 1px solid rgba(255, 255, 255, 0.8);
      background: rgba(255, 255, 255, 0.6);
    }
  }

  .list {
    overflow-y: auto;
    height: calc(100vh - 62px - 58px);
    position: relative;
    z-index: 2;
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background: linear-gradient(180deg, #FFFFFF 0%, #F6F8FA 6%, #EDF1F4 8%, #F2F7FA 100%);

    .list-item {
      display: flex;
      align-items: center;
      background-color: #f9f9f9;
      margin-bottom: 8px;
      padding: 14px 8px 12px;
      border-radius: 12px;

      .icon-check{
        width: 14px;
        height: 14px;
      }

      .avatar {
        width: 42px;
        height: 42px;
        margin-left: 8px;
        margin-right: 6px;
      }

      .info {
        flex: 1;
        display: flex;
        align-items: center;
        overflow: hidden;
        .name {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .hospital {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 14px;
          color: #7A8494;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #FFFFFF 0%, #F6F8FA 6%, #EDF1F4 8%, #F2F7FA 100%);
  height: calc(100vh - 62px);
  position: relative;
  top: 0;
  z-index: 2;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
.confirm-button {
  height: 42px;
  margin: 0 10px;
  width: calc(100% - 20px);
  background-color: #EB1700;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 42px;
  box-sizing: border-box;
  border: none;
  border-radius: 22px;
  text-align: center;
  cursor: pointer;
}
/deep/ .van-radio-group--horizontal{
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/selectAdmin.vue